import { useTheme } from "../ThemeContext";
import T from "../i18n";

export default function Sidebar({ page, setPage, collapsed, novos, clock, lang, nomeLoja, onLogout, chatNaoLidos, lojaId, logoUrl }) {
  const { theme: C } = useTheme();
  const _ = (k) => T(lang, k);

  const items = [
    { key: "dashboard",    label: _("dashboard"),     icon: "📊", short: "Dash" },
    { key: "pdv",          label: "PDV",               icon: "🏪", short: "PDV" },
    { key: "cambio",       label: "Câmbio",             icon: "💱", short: "Cmb" },
    { key: "moedas",       label: "Exibição Moedas",    icon: "🌎", short: "Mda" },
    { key: "pedidos",      label: _("pedidos"),        icon: "🛒", short: "Ped", badge: novos },
    { key: "entregadores", label: "Entregadores",      icon: "🏍️", short: "Ent" },
    { key: "relatorios",   label: _("relatorios"),     icon: "📈", short: "Rel" },
    { key: "devo_entregadores", label: "Devo Entregadores", icon: "💸", short: "Dev" },
    { key: "cadastro",     label: _("cadastro"),       icon: "📋", short: "Cad" },
    { key: "config",       label: _("configuracao"),   icon: "⚙️", short: "Cfg" },
    { key: "bot",          label: "Bot WhatsApp",      icon: "💬", short: "Bot" },
  ];

  return (
    <div style={{
      width: collapsed ? 68 : 220, minWidth: collapsed ? 68 : 220,
      background: C.sidebar, borderRight: `1px solid ${C.border}`,
      padding: collapsed ? "20px 8px" : "20px 12px",
      display: "flex", flexDirection: "column",
      position: "sticky", top: 0, height: "100vh",
      transition: "all .3s ease", overflowY: "auto", overflowX: "hidden"
    }}>

      {/* Logo MixUp */}
      <div style={{ textAlign: "center", marginBottom: 6, padding: collapsed ? "0" : "0 8px" }}>
        <div style={{ fontFamily: "'Plus Jakarta Sans'", fontWeight: 800, fontSize: collapsed ? 14 : 22, lineHeight: 1 }}>
          <span style={{ color: C.red }}>Mix</span><span style={{ color: C.green }}>Up</span>
        </div>
        {!collapsed && (
          <div style={{ fontSize: 10, color: C.textMuted, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginTop: 4 }}>
            {_("painelLojista")}
          </div>
        )}
      </div>

      {/* Logo da loja + Nome + ID */}
      {!collapsed && nomeLoja && (
        <div style={{ textAlign: "center", padding: "8px 10px", borderRadius: 10, background: C.red + "10", border: "1px solid " + C.red + "25", marginBottom: 8 }}>
          {logoUrl ? (
            <img src={logoUrl} alt="Logo" style={{ width: 48, height: 48, borderRadius: 10, objectFit: "cover", marginBottom: 6, border: "2px solid " + C.red + "30" }} onError={function(e) { e.target.style.display = "none"; }} />
          ) : null}
          <div style={{ fontSize: 12, fontWeight: 700, color: C.red, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{nomeLoja}</div>
          {lojaId ? (
            <div style={{ fontSize: 10, fontWeight: 700, color: C.textMuted, marginTop: 3, letterSpacing: "0.05em" }}>ID: {lojaId}</div>
          ) : null}
        </div>
      )}
      {collapsed && logoUrl && (
        <div style={{ textAlign: "center", marginBottom: 8 }}>
          <img src={logoUrl} alt="Logo" style={{ width: 36, height: 36, borderRadius: 8, objectFit: "cover", border: "2px solid " + C.red + "30" }} onError={function(e) { e.target.style.display = "none"; }} />
        </div>
      )}

      <div style={{ height: 1, background: C.border, margin: "8px 0 12px" }} />

      {/* Menu principal — flat, sem submenus */}
      <div style={{ flex: 1 }}>
        {items.map(function(item) {
          var active = page === item.key;
          return (
            <div key={item.key} className="nav-item" onClick={function() { setPage(item.key); }}
              style={{
                display: "flex", alignItems: "center",
                justifyContent: collapsed ? "center" : "flex-start",
                padding: collapsed ? "11px 0" : "11px 14px",
                fontSize: collapsed ? 11 : 13, fontWeight: 600,
                marginBottom: 3, borderRadius: 10, cursor: "pointer",
                position: "relative", gap: 10,
                background: active ? "linear-gradient(135deg, " + C.red + ", " + C.red + "CC)" : "transparent",
                color: active ? "#fff" : C.textSoft,
                boxShadow: active ? "0 4px 16px " + C.red + "30" : "none",
                transition: "all .2s"
              }}>
              <span style={{ fontSize: collapsed ? 16 : 17, lineHeight: 1 }}>{item.icon}</span>
              {!collapsed && <span style={{ flex: 1 }}>{item.label}</span>}
              {item.badge > 0 && (
                <span style={{
                  position: collapsed ? "absolute" : "static",
                  top: collapsed ? 2 : undefined, right: collapsed ? 2 : undefined,
                  background: active ? "rgba(255,255,255,.25)" : C.red,
                  color: "#fff", fontSize: collapsed ? 9 : 11, fontWeight: 800,
                  padding: collapsed ? "1px 5px" : "2px 8px", borderRadius: 8,
                  minWidth: 18, textAlign: "center"
                }}>{item.badge}</span>
              )}
            </div>
          );
        })}
      </div>

      {/* Rodapé */}
      <div style={{ borderTop: "1px solid " + C.border, paddingTop: 12 }}>
        <div style={{ textAlign: "center", padding: collapsed ? "4px 0" : "4px 10px", marginBottom: 8 }}>
          {!collapsed && <div style={{ fontSize: 11, color: C.textMuted }}>mixupbr.com.br</div>}
          <div style={{ fontSize: collapsed ? 12 : 20, fontWeight: 800, color: C.textSoft, marginTop: collapsed ? 0 : 4 }}>
            {clock.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
          </div>
        </div>
        <div className="nav-item" onClick={onLogout}
          style={{
            display: "flex", alignItems: "center",
            justifyContent: collapsed ? "center" : "flex-start",
            padding: collapsed ? "10px 0" : "10px 14px",
            fontSize: 13, fontWeight: 700, borderRadius: 10,
            cursor: "pointer", color: C.red,
            border: "1px solid " + C.red + "30", background: C.red + "08"
          }}>
          {collapsed ? "↩" : "Sair"}
        </div>
      </div>
    </div>
  );
}
